import React from "react";
import { SpreadsheetReference } from "@common/schemas/spreadsheetReference.schema";
import { buildRangeParts } from "@components/spreadsheet/spreadsheetUtils";
import { SpreadsheetIcon } from "@icons";
import { BreakableText } from "@design-system/BreakableText/BreakableText";
import classNames from "classnames";
import styles from "./SpreadsheetRefChip.module.scss";

interface SpreadsheetRefChipProps {
    reference: SpreadsheetReference;
    onClick?: () => void;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
}

export const SpreadsheetRefChip: React.FC<SpreadsheetRefChipProps> = React.memo(
    function SpreadsheetRefChip({
        reference,
        onClick,
        onMouseEnter,
        onMouseLeave,
    }) {
        const { rows, cols } = buildRangeParts(reference.cells);

        return (
            <div className={styles.chipContainer}>
                <span
                    className={classNames(styles.chip, {
                        [styles.clickable]: onClick,
                    })}
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}
                    onClick={onClick}
                >
                    <SpreadsheetIcon className={styles.icon} aria-hidden />
                    <BreakableText
                        className={styles.labelRow}
                        text={rows}
                        showTooltip
                    />
                    <BreakableText
                        className={styles.labelCol}
                        text={cols}
                        showTooltip
                    />
                </span>
            </div>
        );
    },
);
